import { styled } from 'styled-components'
import { m } from 'motion/react'

export const Container = styled(m.div)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.grayBackgroundWhite};
`

export const Title = styled.div`
  margin-top: 36px;
  color: ${({ theme }) => theme.colors.black};
  font-size: 28px;
  line-height: 31px;
  font-weight: 700;
  margin-bottom: 12px;
`

export const Subtitle = styled.div`
  color: ${({ theme }) => theme.colors.secondaryDark};
  font-size: 18px;
  line-height: 20px;
  margin-bottom: 40px;
`
